/**
 * Bulk Action Bar Component
 * Sticky bar that appears when users are selected
 * Shows count and action buttons (Training, New Users, Clear)
 */

import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { AdminColors } from '../../constants/adminColors';
import FontFamily from '../../../../constants/fonts';

interface BulkActionBarProps {
  selectedCount: number;
  onFundamentals: () => void;
  onLighthouse: () => void;
  onAdvFundamentals: () => void;
  onNewUsers: () => void;
  onClearSelection: () => void;
}

const BulkActionBar: React.FC<BulkActionBarProps> = ({
  selectedCount,
  onFundamentals,
  onLighthouse,
  onAdvFundamentals,
  onNewUsers,
  onClearSelection,
}) => {
  if (selectedCount === 0) return null;

  return (
    <View style={styles.container}>
      <Text style={styles.countText}>
        {selectedCount} user{selectedCount !== 1 ? 's' : ''} selected
      </Text>
      
      <View style={styles.actions}>
        <TouchableOpacity style={styles.button} onPress={onFundamentals} activeOpacity={0.8}>
          <Text style={styles.buttonText}>Fundamentals</Text>
        </TouchableOpacity>
        
        <TouchableOpacity style={styles.button} onPress={onLighthouse} activeOpacity={0.8}>
          <Text style={styles.buttonText}>Lighthouse</Text>
        </TouchableOpacity>
        
        <TouchableOpacity style={styles.button} onPress={onAdvFundamentals} activeOpacity={0.8}>
          <Text style={styles.buttonText}>Adv Fundamentals</Text>
        </TouchableOpacity>
        
        <TouchableOpacity style={styles.button} onPress={onNewUsers} activeOpacity={0.8}>
          <Text style={styles.buttonText}>New Users</Text>
        </TouchableOpacity>
        
        <TouchableOpacity style={styles.clearButton} onPress={onClearSelection} activeOpacity={0.8}>
          <Text style={styles.clearText}>Clear Selection</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: AdminColors.blue900,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 8,
    marginBottom: 10,
    gap: 10,
    shadowColor: '#01346F',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 5,
  },
  countText: {
    fontSize: 13,
    lineHeight: 18,
    fontWeight: '600',
    color: AdminColors.textOnDark,
    fontFamily: FontFamily.bold,
    flex: 1,
  },
  actions: {
    flexDirection: 'row',
    gap: 6,
    flexWrap: 'wrap',
  },
  button: {
    paddingHorizontal: 14,
    paddingVertical: 5,
    height: 30,
    borderRadius: 14,
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.3)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 12,
    lineHeight: 16,
    fontWeight: '600',
    color: AdminColors.textOnDark,
    fontFamily: FontFamily.bold,
  },
  clearButton: {
    paddingHorizontal: 12,
    paddingVertical: 5,
    height: 30,
    borderRadius: 14,
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
  },
  clearText: {
    fontSize: 12,
    lineHeight: 16,
    fontWeight: '600',
    color: 'rgba(255, 255, 255, 0.7)',
    fontFamily: FontFamily.bold,
  },
});

export default BulkActionBar;
